export default {
    ExternalOrders: {
        addressTips: 'Pickup orders do not allow a delivery address',
        number: 'Third-party/internal Order No.',
        Platform: 'Platform status',
        Refund: 'Refund status',
        Circulation: 'Circulation status',
        Write: 'Write-back status',
        Consignee: 'Consignee name',
        Mobile: 'Phone number',
        Payment: 'Payment time',
        Order: 'Order time',
        Create: 'Create order',
        store: 'Manually download authorized store orders',
        byorder: 'Manually download authorized channel orders',
        bytime: 'Manually download authorized store orders (by time)',
        Abnormality: 'Reprocess Order',
        Online: 'Online Order No. (one Order No. per line, maximum of 100 Order No.s allowed. Enter with new line or separated by commas)',
        enter: 'Please enter the Charge Item',
        select: 'Please select the category',
        form: {
            number: 'Customer Order No.',
            order: 'CSG Order No.',
            Store: 'Store',
            Channel: 'Channel',
            Circulation: 'Circulation status',
            Reason: 'Circulation failure reason',
            Write: 'Write-back status',
            type: 'Order Type',
            source: 'Order Source',
            Platform: 'Platform status',
            Refund: 'Refund status',
            receiving: 'Platform receipt status',
            Method: 'Payment method',
            Mobistatusle: 'Payment status',
            Buyer: 'Buyer message',
            Merchant: "Merchant's Comments",
            products: 'Number of products',
            amount: 'Total amount of goods',
            Discount: 'Total discount',
            Total: 'Total receivable amount',
            actual: 'Buyer paid amount',
            undertakes: 'Merchant bears the discount amount',
            Preferential: 'Third party bears the discount amount',
            Freight: 'Shipping cost',
            nickname: 'Buyer nickname',
            Flag: 'Flag',
            Consignee: 'Consignee name',
            Mobile: 'Phone number',
            Shipping: 'Shipping address',
            Invoice: 'Invoice type',
            header: 'Invoice title',
            content: 'Invoice content',
            Payment: 'Payment Order No.',
            Logistics: 'Logistics method',
            Three: '3rd Party Order Time',
            time: 'Payment time',
            Pull: 'Pull time',
            Confirm: 'Confirm inbound time',
            Please: 'Please select the exception order',
        },
        dialog: {
            orders: 'Download order',
            number: 'Download by Order No. (support multiple orders, separated by commas)',
            Downloadtime: 'Download by time',
            Store: 'Store',
            OrderNo: 'Order No.',
            Timetype: 'Time type',
            Time: 'Time',
            select: 'Please select the store',
            enter: 'Please enter the Order No.',
            type: 'Please select the time type',
            Please: 'Please select the time',
            placement: 'Order time',
            Payment: 'Payment time',
            Notification: 'Notification of delivery time',
            Last: 'Last modified time',
        },
        download: {
            Add: 'Add store',
            Store: 'Store name',
            selected: 'Store not selected',
            Start: 'Start time',
            Within: 'Within 3 days from the end time',
            End: 'End time',
            days: 'Within 3 days from the start time',
            content: 'Please enter content',
            Download: 'Download now',
            ID: 'ID or Order No. cannot be empty',
            You: 'Maximum 100 can be entered',
            Please: 'Please select a store',
            time: 'Please select a start time',
            select: 'Please select an end time',
            order: 'Manually download orders',
        },
        newAdd: {
            OrderDate: 'Order date',
            OriginalWarehouse: 'Original warehouse',
            Ouantity: 'Ouantity',
            AccountCode: 'Account code',
            TaxCode: 'Tax Code',
            Currency: 'Currency',
            DeliveryName: 'Delivery Name',
            DeliveryPhone: 'Delivery Phone',
            mail: 'mail',
            DeliveryAddress1: 'Delivery Address 1',
            DeliveryAddress2: 'Delivery Address 2',
            DeliveryState: 'State',
            DeliveryPostcode: 'Delivery Postcode',
            DeliverySuburb: 'Delivery Suburb',
            DestinationCountry: 'Country',
            emailAddress: 'Postal Email Address',
            comments: 'comments',
            buyerRemarks: 'buyer remarks',
            ShippingMethod: 'Shipping Type',
            receivingInformation: 'Buyer And Receiving Information',
            chooseShippingAddress: 'Choose Shipping Address',
            anomalyDetected: 'Anomalies detected in the delivery address. Please verify or choose a suggestion.',
            anomalyDetected2: 'Address verification service is temporarily unavailable. Please edit the original address manually.',
            anomalyDetected3Pre: 'Unable to generate a suggestion address. Fields marked ! may be incorrect — verify on',
            anomalyDetected3Post: 'and correct manually.',
            currentAddress: 'Current Address',
            suggestion: 'Suggestion',
            RECOMMENDED: 'RECOMMENDED',
            verifiedInfo: 'Verified Information',
            buyerAndReceivingInfo: 'Buyer And Receiving Information',
            editAddress: 'Edit Address',
            doneEdit: 'Done',
            useOriginal: 'Use Original',
            useSuggestion: 'Use Suggestion',
            selectCurrentAddressTip: 'Please Select Current Address',
            ProductID: 'Product ID',
            ProductSKU: 'SKU',
            ProductName: 'Product name',
            Barcode: 'Barcode',
            Supplier: 'Supplier',
            ExternalSku: 'External SKU',
        },
        // ExternalOrders page
        page: {
            orderIdLabel: 'Order ID',
            orderStatusLabel: 'Order Status',
            fulfillmentLabel: 'Fulfillment',
            paymentStatusLabel: 'Payment Status',
            warehouseLabel: 'Warehouse',
            eligibleLabel: 'Eligible',
            processingStatusLabel: 'Processing Status',
            processingLabel: 'Processing',
            exceptionLabel: 'Exception',
            processingStatusException: 'Exception',
            processingStatusProcessing: 'Processing',
            processingStatusWriteback: 'Writeback',
            processingStatusUncaptured: 'Uncaptured',
            retryBtn: 'Retry',
            pullBtn: 'Pull',
            dialogTitle: 'Exception',
            dialogTip: 'Resolve the issue and click Retry to re-process this order.',
            errorMessageLabel: 'Error message:',
            closeBtn: 'Close',
        },
        EDI: {
            summaryException: 'Exception',
            summaryAwaitingClientApproval: 'Awaiting Client Approval',
            summaryInProgress: 'In Progress',
            summaryComplete: 'Complete',
            filterOrderNo: 'Order No',
            filterStore: 'Store',
            filterRetailer: 'Retailer',
            filterEdiStatus: 'EDI Status',
            filterActionOwner: 'Action Owner',
            columnOrderNo: 'Order No.',
            columnRetailer: 'Retailer',
            columnCustomer: 'Customer',
            columnStore: 'Store',
            columnEdiStatus: 'EDI Status',
            columnActionOwner: 'Action Owner',
            columnReceived: 'Received',
            columnAction: 'Action',
            detailCurrentStep: 'Current step',
            detailActionOwner: 'Action owner',
            detailOrderNumbers: 'Order numbers',
            detailRetailerPo: 'Retailer PO',
            detailClientErpNo: 'Client ERP No.',
            detailCsgOrderNo: 'CSG Order No.',
            detailProcessingTimeline: 'Processing timeline',
            detailDeliveryAddress: 'Delivery Address',
            detailRecipient: 'Recipient',
            detailPhone: 'Phone',
            detailAddress: 'Address',
            detailSuburb: 'Suburb',
            detailStatePostcode: 'State / Postcode',
            detailCountry: 'Country',
            detailApproveAndContinue: 'Approve And Continue',
            detailOrderLines: 'Order lines',
            detailItems: 'Items',
            detailSku: 'Barcode',
            detailQty: 'Qty',
            detailMatch: 'Match',
            MatchStatus1: 'Matched',
            MatchStatus2: 'Not Matched',
            detailEdiPayload: 'EDI payload',
            detailInternalOnly: 'Internal only',
            detailClose: 'Close',
        }
    }
};
